import React, { useState, useEffect } from 'react';
import Input from '#/components/Input/index';
import Color from '#/components/Color/index';
import RangeSlider from '#/components/RangeSlider/index';
import Button from '#/components/Button';
import MultiSelectFetch from '#/components/MultiSelectFetch';
import MultiSelectStatic from '#/components/MultiSelectStatic';
import OrderAscDesc from '#/components/OrderAscDesc';
import ToggleSwitch from '#/components/ToggleSwitch';
import Tooltip from '#/components/Tooltip';
import {WIDGET_TYPES_IDS} from '#/enums/widgetTypes';
import { AUXILIARY_OPTIONS } from '#/enums/auxiliaryOptionTypes';
import { ObjectUtils } from '#/utils/utils';

import styles from './styles.module.css';

import {
  fetchClientFilter,
  fetchBusinessUnitFilter,
  fetchWorkplaceFilter,
  fetchCompaniesFilter,
  fetchTimeTrackingTypesFilter,
  fetchServiceTypesFilter,
  fetchAbsenceSituationFilter,
  fetchOccurrenceReasonFilter,
  fetchEventsFilter,
  fetchPersonFilter,
  fetchAreaFilter,
  fetchApprovalReasonFilter,
  fetchAbsenceSituationStatic
} from '#/api/filterService';
import { SelectedItemsProvider } from '#/providers/selectedItemsProvider';

import { useTranslation } from "react-i18next";



function DynamicFilters({ binds, resetTrigger }) {
  const { t } = useTranslation();
  const TOP_EVENTS_TIME_TRACKING_WIDGET = 38;

  const getSelectedItems = (entityName) => {
    return binds
      .filter(b => b.entityName === entityName && b.widgetId === TOP_EVENTS_TIME_TRACKING_WIDGET)
      .flatMap(b => b.dashboardWidgetBindDtos || []);
  };

  const [timeTrackingSelected, setTimeTrackingSelected] = useState(() => getSelectedItems('TIME_TRACKING_TYPE'));
  
  const [absenceSituationSelected, setAbsenceSituationSelected] = useState(() => getSelectedItems('ABSENCE_SITUATION'));
  
  const handleTimeTrackingSelect = (bind, items) => {
    setTimeTrackingSelected(items);
    handleSelect(bind, items);
  };
  
  const handleAbsenceSelect = (bind, items) => {
    setAbsenceSituationSelected(items);
    handleSelect(bind, items);
  };

  useEffect(() => {
    setTimeTrackingSelected(getSelectedItems('TIME_TRACKING_TYPE'));
    setAbsenceSituationSelected(getSelectedItems('ABSENCE_SITUATION'));
  }, [resetTrigger]);

  function handleSelect(bind, item) {
    bind.dashboardWidgetBindDtos = item;
  }

  return (
    <div className={styles.flexboxWrapper}>
      {
        binds.map(bind => {
          bind.dashboardWidgetBindDtos = bind.dashboardWidgetBindDtos ? bind.dashboardWidgetBindDtos : [];
          let viewOnlyItemsId = [];

          switch (bind.widgetId) {
            case 23:
              viewOnlyItemsId = [3,4,5,6,10,11,14,15,16,17,62,63,64,65,83,84,85,86]
            break;
            case 53:
              viewOnlyItemsId = [3, 4, 5, 6, 14, 15, 16, 17, 62, 63, 64, 65]
              break;
            default:
              viewOnlyItemsId = [];
          }
          
          switch (bind.entityName) {
            case 'CLIENT':
              return (
                <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                  <MultiSelectFetch 
                        key={bind.id} 
                        selectedItems={bind.dashboardWidgetBindDtos} 
                        placeHolder={`${t('SELECT')} ${t('CLIENTS').toLowerCase()}`}
                        title={t('CLIENTS')}
                        onSelect={item => handleSelect(bind, item)}
                        fetchItems={fetchClientFilter}
                  />
                </SelectedItemsProvider>     
              )      
            case 'WORKPLACE':
              return (
                 <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                    <MultiSelectFetch
                            key={bind.id}
                            selectedItems={bind.dashboardWidgetBindDtos}
                            placeHolder={`${t('SELECT')} ${t('WORKPLACES_OR_COST_CENTER').toLowerCase()}`}
                            title={t('WORKPLACES_OR_COST_CENTER')}
                            onSelect={item => handleSelect(bind, item)}
                            fetchItems={fetchWorkplaceFilter}
                    />
                  </SelectedItemsProvider> )
            case 'BUSINESS_UNIT':
              return  (
                <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                   <MultiSelectFetch
                        key={bind.id}
                        selectedItems={bind.dashboardWidgetBindDtos}
                        placeHolder={`${t('SELECT')} ${t('BUSINESSES_UNIT').toLowerCase()}`}
                        title={t('BUSINESSES_UNIT')}
                        onSelect={item => handleSelect(bind, item)}
                        fetchItems={fetchBusinessUnitFilter}
                    />
                </SelectedItemsProvider> )
            case 'COMPANY':
              return (
                <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                  <MultiSelectFetch
                        key={bind.id}
                        selectedItems={bind.dashboardWidgetBindDtos} 
                        placeHolder={`${t('SELECT')} ${t('COMPANIES').toLowerCase()}`}
                        title={t('COMPANIES')}
                        onSelect={item => handleSelect(bind, item)}
                        fetchItems={fetchCompaniesFilter}
                  />
                </SelectedItemsProvider>)
            case 'TIME_TRACKING_TYPE':
              return (
                <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                        <MultiSelectStatic
                          key={bind.id}
                          selectedItems={bind.dashboardWidgetBindDtos} 
                          placeHolder={`${t('SELECT')} ${t('TIME_TRACKING_TYPE').toLowerCase()}`}
                          title={t('TIME_TRACKING_TYPE')}
                          onSelect={item => handleTimeTrackingSelect(bind, item)}
                          fetchItems={fetchTimeTrackingTypesFilter}
                          viewOnlyItemsId={viewOnlyItemsId}
                          disabled={bind.widgetId === TOP_EVENTS_TIME_TRACKING_WIDGET && absenceSituationSelected.length > 0}
                        />
                </SelectedItemsProvider> );
              case 'SERVICE_TYPE':
                return  (
                  <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                    <MultiSelectFetch
                              key={bind.id}
                              selectedItems={bind.dashboardWidgetBindDtos} 
                              placeHolder={`${t('SELECT')} ${t('SERVICE_TYPE').toLowerCase()}`}
                              title={t('SERVICE_TYPE')}
                              onSelect={item => handleSelect(bind, item)}
                              fetchItems={fetchServiceTypesFilter}
                    />
                  </SelectedItemsProvider> 
                  )
              case 'ABSENCE_SITUATION':
                return  (
                  <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}> 
                    {
                      bind.widgetId === TOP_EVENTS_TIME_TRACKING_WIDGET ? (
                        <MultiSelectStatic
                          key={bind.id}
                          selectedItems={bind.dashboardWidgetBindDtos} 
                          placeHolder={`${t('SELECT')} ${t('ABSENCE_SITUATION').toLowerCase()}`}
                          title={t('ABSENCE_SITUATION')}
                          onSelect={item => handleAbsenceSelect(bind, item)}
                          fetchItems={fetchAbsenceSituationStatic} 
                          viewOnlyItemsId={viewOnlyItemsId}
                          disabled={timeTrackingSelected.length > 0}
                        />
                      ) : 
                      (
                        <MultiSelectFetch
                          key={bind.id}
                          selectedItems={bind.dashboardWidgetBindDtos} 
                          placeHolder={`${t('SELECT')} ${t('ABSENCE_SITUATION').toLowerCase()}`}
                          title={t('ABSENCE_SITUATION')}
                          onSelect={item => handleSelect(bind, item)}
                          fetchItems={fetchAbsenceSituationFilter} 
                        />
                      )
                    }
                  </SelectedItemsProvider> 
                  )
              case 'EVENT':
                return  (
                  <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}> 
                    <MultiSelectStatic
                              key={bind.id}
                              selectedItems={bind.dashboardWidgetBindDtos} 
                              placeHolder={`${t('SELECT')} ${t('EVENTS').toLowerCase()}`}
                              title={t('EVENTS')}
                              onSelect={item => handleSelect(bind, item)}
                              fetchItems={fetchEventsFilter}
                    />
                  </SelectedItemsProvider> 
                  )
              case 'OCCURRENCE_REASON':
                return  (
                  <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}> 
                    <MultiSelectFetch
                              key={bind.id}
                              selectedItems={bind.dashboardWidgetBindDtos} 
                              placeHolder={`${t('SELECT')} ${t('OCCURRENCE_REASON').toLowerCase()}`}
                              title={t('OCCURRENCE_REASON')}
                              onSelect={item => handleSelect(bind, item)}
                              fetchItems={fetchOccurrenceReasonFilter}
                    />
                  </SelectedItemsProvider> 
                  )
                    case 'PERSON':
                      return (
                        <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                          <MultiSelectFetch
                            key={bind.id}
                            selectedItems={bind.dashboardWidgetBindDtos}
                            placeHolder={`${t('SELECT')} ${t('PERSONS').toLowerCase()}`}
                            title={t('PERSONS')}
                            onSelect={item => handleSelect(bind, item)}
                            fetchItems={fetchPersonFilter}
                          />
                        </SelectedItemsProvider>
                        )
                    case 'AREA':
                      return (
                        <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                          <MultiSelectFetch
                            key={bind.id}
                            selectedItems={bind.dashboardWidgetBindDtos}
                            placeHolder={`${t('SELECT')} ${t('AREAS').toLowerCase()}`}
                            title={t('AREAS')}
                            onSelect={item => handleSelect(bind, item)}
                            fetchItems={fetchAreaFilter}
                          />
                        </SelectedItemsProvider>
                        )
                    case 'APPROVAL_REASON':
                      return (
                        <SelectedItemsProvider onSelect={item => handleSelect(bind, item)}>
                          <MultiSelectFetch
                            key={bind.id}
                            selectedItems={bind.dashboardWidgetBindDtos}
                            placeHolder={`${t('SELECT')} ${t('APPROVAL_REASON').toLowerCase()}`}
                            title={t('APPROVAL_REASON')}
                            onSelect={item => handleSelect(bind, item)}
                            fetchItems={fetchApprovalReasonFilter}
                          />
                        </SelectedItemsProvider>
                        )
                    default:
                      return null;
          }
        })
      }
    </div>
  )
}

function getBinds(widgetBindDtos) {
  return widgetBindDtos && widgetBindDtos.length > 0 ? JSON.parse(JSON.stringify(widgetBindDtos)) : [];
}

function WidgetFilter({ widget, callBack, showBtnClear = true }) {
  const [title, setTitle] = useState(widget.title);
  const [defaultBackgroundColor, setDefaultBackgroundColor] = useState(widget.defaultBackgroundColor);
  const [defaultFontColor, setDefaultFontColor] = useState(widget.defaultFontColor);
  const [widgetBindDtos, setWidgetBindDtos] = useState(getBinds(widget.widgetBindDtos));
  const [exhibition, setExhibition] = useState(widget.exhibition);
  const [ordination, setOrdination] = useState(widget.ordination);
  const [clearInputvalue, setClearInputValue] = useState(widget.title);
  const [auxiliaryOptionsDto, setAuxiliaryOptionsDto] = useState(widget.auxiliaryOptionsDto);
  const { t } = useTranslation();
  const [resetTrigger, setResetTrigger] = useState(0);


  const handleSave = () => {
    widget.title = title;
    widget.defaultBackgroundColor = defaultBackgroundColor;
    widget.defaultFontColor = defaultFontColor;
    widget.exhibition = exhibition;
    widget.widgetBindDtos = widgetBindDtos;
    widget.ordination = ordination;
    widget.auxiliaryOptionsDto = auxiliaryOptionsDto;
    
    if(callBack) {
      callBack();
    }
  }

  const clear = () => {
    setTitle(widget.title)
    setDefaultBackgroundColor(widget.defaultBackgroundColor);
    setDefaultFontColor(widget.defaultFontColor);
    setWidgetBindDtos(getBinds(widget.widgetBindDtos));
    setExhibition(widget.exhibition);
    setOrdination(widget.ordination);
    setClearInputValue(widget.title);
    setAuxiliaryOptionsDto(widget.auxiliaryOptionsDto || []);
    setResetTrigger(prev => prev + 1);
  }

  const getAuxiliaryOptionToggleChecked = (auxiliaryOptions, auxiliaryOptionId) => {
    if(ObjectUtils.notEmptyNorNullNorUndefined(auxiliaryOptions)) {
      const found = auxiliaryOptions.find(
        aux => aux.widgetAuxiliaryOptionId === auxiliaryOptionId
      );
      return found ? !!found.value : false;
    }
    return false
  }

  const setAuxiliaryOptionState = (oldState, auxiliaryOptionId) => {
    const currentState = Array.from(oldState || [] );

    const idx = currentState.findIndex(
      aux => aux.widgetAuxiliaryOptionId === auxiliaryOptionId
    );

    if(idx === -1) {
      return [
        ...currentState,
        { widgetAuxiliaryOptionId: auxiliaryOptionId, value: true }
      ];
    }

    const updated = [...currentState];
    updated[idx] = {
      ...updated[idx],
      value: !updated[idx].value
    };
    return updated;
  }

  function onChangeOrdination(order) {
    setOrdination(order);
  }

  function onChangeName(name) {
    setTitle(name);
    setClearInputValue(name);
  }

  function onSelectColorBackground(color) {
    setDefaultBackgroundColor(color);
  }

  function onSelectColorFont(color) {
    setDefaultFontColor(color);
  }

  function onChangeExhibition(value) {
    setExhibition(value);
  }

  return (
    <div className={styles.wrapperTB}>
      <h1 className={[styles.title, styles.wrapperLR, styles.wrapperTB].join(' ')}>{t('EDIT_WIDGET')} <strong>{widget.title}</strong></h1>
      <hr />
      <div className={[styles.wrapperLR, styles.wrapperTB].join(' ')}>
          <div className={styles.separator}>
            <Input focus={true} title={t('NAME')} width={'100%'} onChange={onChangeName} borderColor='#e5e5e5' placeholder={`${t('RENAME_WIDGET')} ${title}`} valueDefault={clearInputvalue} />
          </div>
          <div className={styles.separator} style={{ display: 'flex', flexDirection: 'row'}}>
            {widget.allowChangeColorBackground ? <div className={styles.spaceColors}>
              <Color borderColor='#bdbdbd' title={t('BACKGROUND_COLOR')} currentColor={defaultBackgroundColor} onSelect={onSelectColorBackground}/>
            </div> : null}
            {widget.allowChangeColorFont ? <Color borderColor='#bdbdbd' title={t('TEXT_COLOR')} currentColor={defaultFontColor} onSelect={onSelectColorFont}/> : null}
          </div>

          {widgetBindDtos && widgetBindDtos.length > 0 ? 
            <>
              <hr className={styles.hrBody}/>
                <DynamicFilters binds={widgetBindDtos} resetTrigger={resetTrigger}/> 
                {widget.i === WIDGET_TYPES_IDS.COMPUTE_EVENT && (
                  <div className={styles.toggleSwitchContainer}>
                    <div className={styles.toggleSwitchLabel}>
                        <span>{t('GENERATE_RESULT_WITHOUT_APPORTIONMENT')}</span>
                        <div className={styles.toggleSwitchLabelIcon}>
                            <Tooltip content={t('ICON_TOOLTIP_TEXT_TOOGLE_SWITCH_HOVER')}>
                              <span className={styles.iconCircleQuestioRegular} />
                            </Tooltip>
                        </div>
                    </div>
                    <ToggleSwitch 
                      checked = {
                        getAuxiliaryOptionToggleChecked(auxiliaryOptionsDto, AUXILIARY_OPTIONS.IGNORE_APPORTIONMENT)
                      } 
                      onClick = {() => setAuxiliaryOptionsDto(oldState => {
                          return setAuxiliaryOptionState(oldState, AUXILIARY_OPTIONS.IGNORE_APPORTIONMENT)
                        })
                      }
                    />
                  </div>
                )} 
              <hr className={styles.hrBody}/>
            </> : null
          }
          
          { widget.allowExhibition || widget.allowOrdination ?
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              {widget.allowExhibition ? 
                <div className={[styles.wrapperTB].join(' ')} style={{width: '50%'}}>
                  <RangeSlider currentValue={exhibition || 10} min={10} max={50} step={10} onChange={onChangeExhibition} title={t('EXHIBITION')} />
                </div> : null}
              {!widget.allowOrdination ? null : 
                <OrderAscDesc defaultActive={ordination} callBack={onChangeOrdination} />
              } 
            </div>
            : null
          }

          { widget.clockingNotTreated ?
            <div className={styles.toggleSwitchContainer}>
              <div className={styles.toggleSwitchLabel}>
                  <span>{t('CLOCKING_NOT_TREATED')}</span>
              </div>
                <ToggleSwitch 
                  checked = {
                    getAuxiliaryOptionToggleChecked(auxiliaryOptionsDto, AUXILIARY_OPTIONS.FLAG_CLOCKING_NOT_TREATED)
                  } 
                  onClick = {() => setAuxiliaryOptionsDto(oldState => {
                      return setAuxiliaryOptionState(oldState, AUXILIARY_OPTIONS.FLAG_CLOCKING_NOT_TREATED)
                    })
                  }
                />
            </div>
            : null
          }

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: '16px'  
        }}>
          <Button buttonType="primary" action={handleSave} noMargin={true} isDisabled={false}>
            {t('SAVE')}
          </Button>

          {showBtnClear ? <Button buttonType="secondary" action={clear} noMargin={true} isDisabled={false}>
            {t('UNDO_CHANGES')}
          </Button> : null}
        </div>
      </div>
    </div>
  );
}

export default WidgetFilter;
